import {
  Home, Users, Calendar, Heart, Wallet, Wrench, CreditCard, DollarSign,
  BarChart3, Crown, Star, Gift, Camera, Eye, ShoppingCart, Calculator,
  FileText, ClipboardList, Settings, Mail, MessageSquare, MessageCircle,
  Bot, Brain, Shield, HardDrive, Database, Monitor, Activity, Headphones,
  Video, Package, Building2, Car, Store, ShoppingBag, Mic, Globe,
  Palette, CalendarDays, Phone, Megaphone, Workflow, Contact, Banknote,
  ListTodo, Smartphone, Plus, UserPlus, Receipt, Film, StickyNote,
  CheckSquare, HelpCircle, Gamepad2,
} from "lucide-react";
import type { PaletteItem } from "@/lib/palette-config";

const iconMap: Record<string, any> = {
  Home, Users, Calendar, Heart, Wallet, Wrench, CreditCard, DollarSign,
  BarChart3, Crown, Star, Gift, Camera, Eye, ShoppingCart, Calculator,
  FileText, ClipboardList, Settings, Mail, MessageSquare, MessageCircle,
  Bot, Brain, Shield, HardDrive, Database, Monitor, Activity, Headphones,
  Video, Package, Building2, Car, Store, ShoppingBag, Mic, Globe,
  Palette, CalendarDays, Phone, Megaphone, Workflow, Contact, Banknote,
  ListTodo, Smartphone, Plus, UserPlus, Receipt, Film, StickyNote,
  CheckSquare, HelpCircle, Gamepad2, User: Users,
};

interface Props {
  results: PaletteItem[];
  selectedIndex: number;
  onSelect: (item: PaletteItem) => void;
  onHover: (index: number) => void;
}

export default function PaletteResults({ results, selectedIndex, onSelect, onHover }: Props) {
  if (results.length === 0) return null;

  // Group by category
  const groups: Record<string, { items: PaletteItem[]; startIndex: number }> = {};
  let idx = 0;
  for (const item of results) {
    const cat = item.category || "Results";
    if (!groups[cat]) {
      groups[cat] = { items: [], startIndex: idx };
    }
    groups[cat].items.push(item);
    idx++;
  }

  let globalIndex = 0;

  return (
    <div className="px-1 py-1">
      {Object.entries(groups).map(([category, group]) => (
        <div key={category}>
          <div className="uppercase text-[10px] tracking-wider text-white/40 px-3 py-1.5 font-medium">
            {category}
          </div>
          {group.items.map((item) => {
            const currentIndex = globalIndex++;
            const isSelected = currentIndex === selectedIndex;
            const Icon = iconMap[item.icon] || Calendar;

            return (
              <button
                key={item.id}
                onClick={() => onSelect(item)}
                onMouseEnter={() => onHover(currentIndex)}
                className={`flex items-center gap-3 w-full px-3 py-2 rounded-lg cursor-pointer transition-all text-left ${
                  isSelected
                    ? "bg-[#B8860B]/10 border border-[#B8860B]/20 text-white"
                    : "hover:bg-white/5 text-white/70 border border-transparent"
                }`}
              >
                <Icon className={`w-4 h-4 flex-shrink-0 ${isSelected ? 'text-[#B8860B]' : 'text-white/40'}`} />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{item.label}</div>
                  {item.description && (
                    <div className="text-xs text-white/40 truncate">{item.description}</div>
                  )}
                </div>
                {isSelected && (
                  <kbd className="text-[10px] text-white/30 bg-white/5 px-1.5 py-0.5 rounded border border-white/10 flex-shrink-0">
                    ↵
                  </kbd>
                )}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
